<div class="experience-courses-accelerator-enrollments-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="enrollments()"></grid-content>
</div>